import { render, staticRenderFns } from "./PrintVolume.vue?vue&type=template&id=357ed44c&scoped=true"
import script from "./PrintVolume.vue?vue&type=script&lang=js"
export * from "./PrintVolume.vue?vue&type=script&lang=js"
import style0 from "./PrintVolume.vue?vue&type=style&index=0&id=357ed44c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357ed44c",
  null
  
)

export default component.exports